enum RfiWorkflowStatusEnum {
    Requested = 'REQUESTED',
    Supplied = 'SUPPLIED',
}

export default RfiWorkflowStatusEnum;
